import { get, patch, post } from "services/httpService";

const SERVICE_URLS = {
  createPlaidLink: () => `plaid/create-plaid-link-token/`,
  createACHLink: () => `plaid/create-user-ach-link/`,
  addFunds: () => `internal-account/initial-investment/`,
  verifyIdentity: () =>
    "/internal-account/internal-account-kyc/verify_identity/",
  resendVerificationCode: () => "/internal-account/resend-kyc-otp-code/",
  verifyNumber: () => "/internal-account/internal-account-kyc/verify_number/",
  updateCitizenshipDetail: () =>
    "/internal-account/internal-account-kyc/citizenship_detail/",
  updateResidentialAddress: () =>
    "/internal-account/internal-account-kyc/residential_address/",
  updateEmploymentStatus: () =>
    "/internal-account/internal-account-kyc/employment_status/",
  updateAnnualIncome: () =>
    "/internal-account/internal-account-kyc/annual_income/",
  updateFundingSourse: () =>
    "/internal-account/internal-account-kyc/funding_source/",
  updateNetWorth: () => "/internal-account/internal-account-kyc/net_worth/",
  updateAffiliation: () =>
    "/internal-account/internal-account-kyc/affiliation/",
  updateSignAgreement: () =>
    "/internal-account/internal-account-kyc/agreement/",
  createAlpacaUser: () => "/internal-account/create-alpaca-user/",
  getAccountDetails: () => "/internal-account/create-cash-transfer/",
  createCashTransfer: () => "/internal-account/create-cash-transfer/",
  getKycDetails: () => "/internal-account/internal-account-kyc/",
  getStates: () => "/dynamic-json-schema/?type=STATE_ABBREVIATIONS",
  updatePlaidConsent: () => "/plaid/update-plaid-link-token/",
  autoInvest: () => "/internal-account/autoinvest/",
  combinedPersonalDetails: () =>
    "/internal-account/internal-account-kyc/combined_personal_details/",
  submitNumber: () => "/internal-account/internal-account-kyc/submit_phone/",
};

export const getKycDetails = () => get(SERVICE_URLS.getKycDetails());

export const verifyIdentity = (data) =>
  patch(SERVICE_URLS.verifyIdentity(), data);

export const resendVerificationCode = (data) =>
  post(SERVICE_URLS.resendVerificationCode(), data);

export const verifyNumber = (data) => patch(SERVICE_URLS.verifyNumber(), data);

export const updateCitizenshipDetail = (data) =>
  patch(SERVICE_URLS.updateCitizenshipDetail(), data);

export const updateResidentialAddress = (data) =>
  patch(SERVICE_URLS.updateResidentialAddress(), data);

export const updateEmploymentStatus = (data) =>
  patch(SERVICE_URLS.updateEmploymentStatus(), data);

export const updateAnnualIncome = (data) =>
  patch(SERVICE_URLS.updateAnnualIncome(), data);

export const updateFundingSourse = (data) =>
  patch(SERVICE_URLS.updateFundingSourse(), data);

export const updateNetWorth = (data) =>
  patch(SERVICE_URLS.updateNetWorth(), data);

export const updateAffiliation = (data) =>
  patch(SERVICE_URLS.updateAffiliation(), data);

export const updateSignAgreement = (data) =>
  patch(SERVICE_URLS.updateSignAgreement(), data);

export const createAlpacaUser = () => post(SERVICE_URLS.createAlpacaUser());

export const getAccountDetails = () => get(SERVICE_URLS.getAccountDetails());

export const createCashTransfer = (data) =>
  post(SERVICE_URLS.createCashTransfer(), data);

export const createPlaidLink = () => {
  const payload = {};
  return post(SERVICE_URLS.createPlaidLink(), payload);
};

export const createACHLink = ({ public_token, accountId }) => {
  const payload = {
    publicToken: public_token,
    accountId: accountId,
  };
  return post(SERVICE_URLS.createACHLink(), payload);
};

export const addFunds = ({ amount }) => {
  const payload = {
    amount,
  };
  return post(SERVICE_URLS.addFunds(), payload);
};

export const getStates = () => get(SERVICE_URLS.getStates());

export const updatePlaidConsent = () => {
  const payload = {};
  return post(SERVICE_URLS.updatePlaidConsent(), payload);
};

export const autoInvest = (payload) => {
  return post(SERVICE_URLS.autoInvest(), payload);
};

export const combinedPersonalDetails = (payload) => {
  return patch(SERVICE_URLS.combinedPersonalDetails(), payload);
};

export const submitNumber = (payload) => {
  return patch(SERVICE_URLS.submitNumber(), payload);
};
